import React from "react";
import firebase from "firebase";
import ActivityIndicator from "react-activity-indicator";
import Select from "react-select";
import noImage from "../../assets/img/no-image.png";

export default class Inputs extends React.Component {
  state = {
    maleImageUrl: null,
    femaleImageUrl: null,
    faculties: [],
    dressCodes: [],
    dressCode: "",
    facultyId: 1
  };

  componentDidMount() {
    const { universityFirebase } = this.props;
    // firebase
    //   .database()
    //   .ref(`${universityFirebase}/faculties`)
    //   .once("value")
    //   .then(snapshot => {
    //     const faculties = snapshot
    //       .val()
    //       .map((item, index) => ({ value: index, label: item }))
    //       .filter(item => !!item);
    //     this.setState({ faculties });
    //   });

    //Get Faculties list
    firebase
      .database()
      .ref(`${universityFirebase}/faculties`)
      .once("value")
      .then(snapshot => {
        const faculties = Object.entries(snapshot.val()).map((item, index) => ({ value: item[0], label: item[1] }))
        faculties.unshift({ value: "all", label: "Select Filter" });
        this.setState({ faculties });
      });
  }

  onImageChange = (event, name) => {
    let reader = new FileReader();
    let fileVar = `file${name}`;
    let imageVar = `image${name}`;
    let file = event.target.files[0];
    this.setState({ [imageVar]: event.target.files[0] });

    reader.onloadend = () => {
      this.setState({
        [fileVar]: file.type,
        [`${name.toLowerCase()}ImageUrl`]: reader.result
      });
    };

    reader.readAsDataURL(file);
  };

  handleSubmit = async () => {
    const { dressCode, facultyId, maleImageUrl, femaleImageUrl, imageMale, imageFemale, fileMale, fileFemale } = this.state;
    const { universityFirebase } = this.props;

    if (dressCode && facultyId >= 0 && maleImageUrl && femaleImageUrl) {
      this.setState({ loading: true }, async () => {
        let maleLocation = `${universityFirebase}/dressCodes/male/${dressCode}`;
        let femaleLocation = `${universityFirebase}/dressCodes/female/${dressCode}/`;

        let maleContentType = {
          contentType: fileMale
        };
        let femaleContentType = {
          contentType: fileFemale
        };

        try {
          // console.log("[js]", maleLocation, imageMale, maleContentType);
          const maleStorageRef = firebase.storage().ref(maleLocation);
          const femaleStorageRef = firebase.storage().ref(femaleLocation);

          await maleStorageRef.put(imageMale, maleContentType);
          const maleUrl = await maleStorageRef.getDownloadURL();

          await femaleStorageRef.put(imageFemale, femaleContentType);
          const femaleUrl = await femaleStorageRef.getDownloadURL();

          await firebase
            .database()
            .ref(`${universityFirebase}/dressCodes/${dressCode}`)
            .update({
              maleImageUrl: maleUrl,
              femaleImageUrl: femaleUrl,
              facultyId: facultyId,
              dressCode: dressCode
            });

          this.props.updateTable();
        } catch (error) {
          console.log("error", error);
        } finally {
          this.setState({ loading: false });
        }
      });
    } else {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน");
    }
  };

  handleChangeSelect = (value, field) => {
    this.setState({ [field]: value.value });
  };

  render() {
    const { loading, dressCode, facultyId, faculties, maleImageUrl, femaleImageUrl } = this.state;
    return (
      <div className={"row"}>
        <div className={"col-md-6"}>
          <div className={"row"}>
            <div className={"col-md-12"}>
              <label>รหัสชุด</label>
              <input type="text" className={"form-control"} value={dressCode} onChange={event => this.setState({ dressCode: event.target.value })} />
              <small>
                <span style={{ color: "red" }}>*ถ้าใส่รหัสซ้ำจะถูกทับกับของเดิม*</span>
              </small>
            </div>
          </div>
          <br />
          <div className={"row"}>
            <div className={"col-md-12"}>
              <label>เลือกคณะ</label>
              <Select value={facultyId} options={faculties} onChange={value => this.handleChangeSelect(value, "facultyId")} />
            </div>
          </div>

          <br />
          <div className={"row"}>
            <div className={"col-md-offset-5 col-md-7"}>
              {loading && <ActivityIndicator number={4} duration={150} activeColor="#0070bf" borderWidth={2} borderRadius="50%" diameter={15} />}
            </div>
          </div>
          <br />
        </div>
        <div className={"col-md-6"}>
          <div className={"row"}>
            <div className={"col-md-5"}>
              <label>รูปชุดครุยผู้ชาย</label>
              <img className={"img-example"} alt={"รูปชุดครุยผู้ชาย"} src={maleImageUrl || noImage} />
              <input type="file" name="Male" accept="image/*" onChange={e => this.onImageChange(e, "Male")} />
            </div>
            <div className={"col-md-5"}>
              <label>รูปชุดครุยผู้หญิง</label>
              <img className={"img-example"} alt={"รูปชุดครุยผู้หญิง"} src={femaleImageUrl || noImage} />
              <input type="file" name="Female" accept="image/*" onChange={e => this.onImageChange(e, "Female")} />
            </div>
            <div className={"col-md-2"}>
              <button className="btn btn-lg btn-success" onClick={this.handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /src/containers/PictureManagement/Inputs.js